/**
 * @generated SignedSource<<54ad807a305d14251789b516b6715fc8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type useEmojiTitleFragment_content$data = Result<{
  readonly contentProperties: {
    readonly latest: {
      readonly defaultTitleEmoji: string | null;
    } | null;
  } | null;
  readonly emojiTitleDraft: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly key: string | null;
      readonly value: string | null;
      readonly version: {
        readonly number: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly emojiTitlePublished: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly key: string | null;
      readonly value: string | null;
      readonly version: {
        readonly number: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly id: string | null;
  readonly " $fragmentType": "useEmojiTitleFragment_content";
}, unknown>;
export type useEmojiTitleFragment_content$key = {
  readonly " $data"?: useEmojiTitleFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEmojiTitleFragment_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "kind": "ScalarField",
        "name": "value"
      },
      {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "number"
          }
        ]
      }
    ]
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useEmojiTitleFragment_content",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "emojiTitlePublished",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "emoji-title-published"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "properties(key:\"emoji-title-published\")"
    },
    {
      "alias": "emojiTitleDraft",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "emoji-title-draft"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "properties(key:\"emoji-title-draft\")"
    },
    {
      "concreteType": "ContentProperties",
      "kind": "LinkedField",
      "name": "contentProperties",
      "plural": false,
      "selections": [
        {
          "concreteType": "PublishedContentProperties",
          "kind": "LinkedField",
          "name": "latest",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "defaultTitleEmoji"
            }
          ]
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "c80367d572bbd2dc3c59e06c0efbe64f";

export default node;
